import { Badge } from "reactstrap"
import Swal from "sweetalert2"

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {

  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

export function devuelveBasePath() {

  let REACT_APP_BACKEND_BASEPATH = process.env.REACT_APP_BACKEND_BASEPATH_LOCAL
  if (process.env.REACT_APP_ENTORNO == "DEV") {
    REACT_APP_BACKEND_BASEPATH = process.env.REACT_APP_BACKEND_BASEPATH_DEV
  }
  if (process.env.REACT_APP_ENTORNO == "PRO") {
    REACT_APP_BACKEND_BASEPATH = process.env.REACT_APP_BACKEND_BASEPATH_PRO
  }
  return REACT_APP_BACKEND_BASEPATH

}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: '2-digit', day: '2-digit', year: 'numeric' }) => {
  if (!value) return value
  // return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
  return new Intl.DateTimeFormat('es-ES', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  // return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
  return new Intl.DateTimeFormat('es-ES', formatting).format(new Date(value))
}

// ** Returns YYYY-MM-DD date
export const formatDateToDatabase = (value) => {
  const date = new Date(value)

  const year = date.getFullYear()

  let month = (1 + date.getMonth()).toString()
  month = month.length > 1 ? month : `0${month}`

  let day = date.getDate().toString()
  day = day.length > 1 ? day : `0${day}`

  return `${year}-${month}-${day}`
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userDataPim')
export const getUserData = () => JSON.parse(localStorage.getItem('userDataPim'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  // if (userRole === 'admin') return '/empresas'
  if (userRole === 'admin') return '/productos'
  if (userRole !== 'admin') return '/login'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

// ** Capitalize First letter
export const capitalizeFirstLetter = (string) => (
  string ? `${string.charAt(0).toUpperCase()}${string.slice(1)}` : ''
)

// ** Slugify
export const slugify = (...args) => {
  const value = args.join(' ')

  return value
    .normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-') // separator
}

// Price, Quantity & Ammount
export const getFormattedPrice = (price) => (
  // new Intl.NumberFormat(undefined, {
  //   style: 'currency',
  //   currency: 'EUR'
  // }).format(price)
  price ? price.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,') : ''
)

export const getFormattedQuantity = (quantity = 0) => (
  quantity ? quantity : ''
)
export const getFormattedAmmount = (price, quantity) => (
  (price && quantity) ? `${((price * quantity) / 100 * 100).toFixed(2)} €` : ''
)

export const automaticDownload = (filename, data) => {
  const hiddenElement = document.createElement('a')
  hiddenElement.href = data
  hiddenElement.target = '_blank'
  hiddenElement.download = filename
  hiddenElement.click()
  setTimeout(() => hiddenElement.remove(), 4000)
}

export const displaySuccessMsg = (msg, displayTime) => {
  if (displayTime) {
    return Swal.fire({
      position: 'center',
      icon: 'success',
      showCloseButton: false,
      timer: displayTime,
      title: msg
    })
  } else {
    return Swal.fire({
      position: 'center',
      icon: 'success',
      title: msg
    })
  }
}

export const displayInfoMsg = (msg, displayTime) => {
  if (displayTime) {
    return Swal.fire({
      position: 'center',
      icon: 'info',
      showCloseButton: false,
      timer: displayTime,
      title: msg
    })
  } else {
    return Swal.fire({
      position: 'center',
      icon: 'info',
      title: msg
    })
  }
}

export const displayErrorMsg = (msg, displayTime) => {
  if (displayTime) {
    return Swal.fire({
      position: 'center',
      icon: 'error',
      showCloseButton: false,
      timer: displayTime,
      title: msg
    })
  } else {
    return Swal.fire({
      position: 'center',
      icon: 'error',
      title: msg
    })
  }
}

export const capitalize = (string) => {
  const loweredString = string.toLowerCase()
  return loweredString.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
}

export const testJSON = (text) => {
  if (typeof text !== "string") {
    return false
  }
  try {
    JSON.parse(text)
    return true
  } catch (error) {
    return false
  }
}

export function inRange(x, min, max) {
  const minVal = min ? min : 0
  const maxVal = max ? max : 99999
  return x >= minVal && x <= maxVal
}

export function getYoutubeId(url) {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)
  if (match && match[2].length === 11) {
    return match[2]
  } else {
    return null
  }
}

// Esta función procesa una cadena de unidades DUN-14 separadas por guiones,
// las limpia, convierte a números y filtra solo los valores válidos (números enteros >= 1)
export const procesarUnidadesDun14 = (entradaUnidades, maxDigitosUnidadesDun14) => {
  const partes = String(entradaUnidades || '')
    .split('-')
    .map(unidad => unidad.trim())
    .filter(unidad => unidad !== '')

  const maxValor = Number.isFinite(maxDigitosUnidadesDun14) ? (10 ** maxDigitosUnidadesDun14) - 1 : null

  const valores = partes.map(fragmento => {
    const coincidencia = fragmento.match(/(\d+[.,]?\d*)/)
    if (!coincidencia) return null
    const numero = parseFloat(coincidencia[1].replace(',', '.'))
    if (!Number.isFinite(numero)) return null
    const entero = Math.floor(numero)
    if (entero < 1) return null
    if (maxValor !== null && entero > maxValor) return null
    return entero
  }).filter(v => v !== null)

  return valores
}

// Devuelve las unidades DUN-14 como string limpio (solo enteros >=1 separados por guiones)
export const limpiarUnidadesDun14 = (entradaUnidades, maxDigitosUnidadesDun14) => {
  const unidades = procesarUnidadesDun14(entradaUnidades, maxDigitosUnidadesDun14)
  return unidades.join('-')
}

/**
 * Calcula el código DUN-14 a partir de las unidades y el EAN
 * @param {number|string} unidades - Número de unidades (primer dígito)
 * @param {string} ean - Código EAN
 * @returns {string} Código DUN-14 completo
 */
function calcularDUN14(unidades, ean) {
  // Paso 1 y 2: Concatenar unidades + EAN
  const unidadesConEan = String(unidades) + String(ean)
  
  // Paso 3: Crear array con los primeros 13 dígitos
  const array1 = unidadesConEan.slice(0, 13).split('').map(Number)
  const primerosTreceDigitos = unidadesConEan.slice(0, 13)
  
  // Paso 4: Crear array alternando 3 y 1  = [3,1,3,1,3,1,3,1,3,1,3,1,3]
  const array2 = Array(13).fill(0).map((_, i) => (i % 2 === 0 ? 3 : 1))
  
  // Paso 5: Multiplicar posiciones de array1 y array2
  const array3 = array1.map((valor, index) => valor * array2[index])
  
  // Paso 6: Sumar todas las posiciones del tercer array
  const suma = array3.reduce((acc, val) => acc + val, 0)
  
  // Paso 7: Encontrar el múltiplo de 10 superior o igual
  const multiplo10 = Math.ceil(suma / 10) * 10
  
  // Paso 8: Calcular el dígito verificador
  const digitoVerificador = multiplo10 - suma
  
  // Paso 9: Concatenar resultado con el dígito verificador
  const dun14 = primerosTreceDigitos + digitoVerificador
  
  return dun14
}

  // Función genera códigos DUN-14 basados en el EAN y las unidades proporcionadas.
export const generarCodigosDun14 = (ean, unidadesInput) => {
  // Limpiar el EAN de cualquier carácter no numérico
  const eanLimpio = String(ean || '').replace(/\D/g, '')
  const unidadesTexto = String(unidadesInput || '').trim()

  if (!unidadesTexto) {
    return { codigos: [], unidades: [], dun14: '' }
  }

  // Procesar las unidades (ignora ceros y texto)
  const unidades = procesarUnidadesDun14(unidadesTexto)
  const partesLimpias = unidades.map(u => String(u))

  const obtenerIndicador = (unidad) => {
    // Indicadores predefinidos para unidades específicas
    const indicadoresPredefinidos = { 6: '1', 10: '2', 12: '3', 20: '4', 24: '5' }
    // Si no está en predefinidos, usar '6' por defecto
    return indicadoresPredefinidos[unidad] || '6'
  }

  // Crear una lista de códigos DUN-14, uno para cada unidad
  const listaCodigos = unidades.map(unidad => {
    //Obtener el indicador correspondiente a la unidad (primeros dígitos del DUN-14)
    const indicador = obtenerIndicador(unidad)

    const codigoDun14 = calcularDUN14(indicador, eanLimpio)

    return codigoDun14
  })

  // Si no hay EAN, devolvemos solo las unidades limpias
  if (!eanLimpio) {
    const dun14 = partesLimpias.join('-')
    return { codigos: [], unidades, dun14 }
  }

  const dun14 = listaCodigos.join('-')

  console.log({ listaCodigos, dun14 })

  return { codigos: listaCodigos, unidades, dun14 }
}

export function getPimUrl(url) {
  return `http://51.75.242.235:8080/media/download/${url.replaceAll("/", "%252F")}`
}

export function getUsableFilesUrl(url) {
  return `${devuelveBasePath()}/${url}`
}

export function makeParrafos(str, divisor, className) {
  return str.split(divisor).map((it, i) => {
    if (it.length > 0) return <div className={className} key={`x${i}`}>{it}</div>
    else return null
  })
}

export function fetchAndDownload(url, filename) {
  return fetch(url, {
    method: 'GET'
  })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob])
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `${filename}`
      )
      // Append to html link element page
      document.body.appendChild(link)
      // Start download
      link.click()
      // Clean up and remove the link
      link.parentNode.removeChild(link)
    })
}

export function cortarCerosExcedentes(str) {
  if (!str.includes(".")) return str

  return parseFloat(str) * 1
}

export function isMobileScreen() {
  return window.matchMedia("(min-width: 500px)").matches
}

export function emptyCache() {
  if ('caches' in window) {
    // Elimino todas las caches de forma asíncrona usando (Promise.All)
    caches.keys().then((names) => {
      return Promise.all(names.map(name => caches.delete(name)))
    }).then(() => {
      console.log('Caches eliminadas')
      // Una vez eliminadas, recargo la página
      window.location.reload()
    }).catch((error) => {
      console.error("Error al eliminar caches: ", error)
    })
  }
}

export function scrollToTopSmooth() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

export function getAccessToken() {
  return JSON.parse(localStorage.getItem('userDataPim'))?.accessToken
}

export function getUserForToken() {
  return JSON.parse(localStorage.getItem('userDataPim'))
}

export function getBackendUsableFilesUrl(url) {
  // pegar el REACT_APP_BACKEND_BASEPATH y quitar el "./public/"
  return `${devuelveBasePath()}/${url.slice(9, url.length)}`
}

export async function existeImagen(url, callback) {
  const res = await fetch(url)
  return res
}

export async function estilosAventanasSweetAlert() {

  const estilosPersonalizados = `
        .estilos-boton-confirm {
            margin-right: 10px !important
        }`

  return estilosPersonalizados
}
//
//La siguiente función pinta un badge en el crud indicando si la culumna está en verde con un valor o en rojo con otro
//
export function pintaBadge(campo, valorOK, valorKO) {
  const statusObj = {
    [valorOK]: 'light-success',
    [valorKO]: 'light-danger'
  }
  
  const getStatusText = (campo) => {
    if (campo == "S") {
      return valorOK
    } else {
      return valorKO
    }
  }

  return (
    <Badge className='text-capitalize' color={statusObj[getStatusText(campo)]} pill>
      {getStatusText(campo)}
    </Badge>
  )
}
